import { Form } from "reactstrap";
import CommonFileUpload from "../../../../CommonElements/CommonFileUpload";

const DropzoneFile = () => {
  return (
    <Form className="m-b-20">
      <CommonFileUpload />
    </Form>
  );
};

export default DropzoneFile;
